import { WithID } from '@fullstory/util/uid';
import { SearchState } from './types';
import { SearchModel, SearchGroup, SearchFilterTypes } from '@fullstory/search-model';
import {
  equalType,
  defaultEventType,
  defaultNotEventType,
  defaultUserType,
  UserType,
  EventType,
  DependentType,
} from '@fullstory/search-types';

// Appends dependents to last searchmodel row and the corresponding uimodel row.
export const appendDependents = (
  state: SearchState,
  key: keyof Pick<SearchModel, 'events' | 'notEvents' | 'users'>,
  data: WithID<DependentType>[],
): SearchState => {
  const last = state.searchModel[key][state.searchModel[key].length - 1];
  if (!last) {
    // You can't append a dependent if there aren't any primary rows!
    return state;
  }
  const uiIndexOf = state.uiModel[key].findIndex(
    (item: SearchGroup<EventType> | SearchGroup<UserType>) => item.primary.id == last.primary.id,
  );

  const _state: SearchState = {
    ...state,
    uiModel: {
      ...state.uiModel,
      [key]: [
        ...state.uiModel[key].slice(0, uiIndexOf),
        {
          ...state.uiModel[key][uiIndexOf],
          dependents: [...(state.uiModel[key][uiIndexOf]?.dependents ?? []), ...data],
        },
        ...state.uiModel[key].slice(uiIndexOf + 1),
      ],
    },
    searchModel: {
      ...state.searchModel,
      [key]: [
        ...state.searchModel[key].slice(0, state.searchModel[key].length - 1),
        {
          ...state.searchModel[key][state.searchModel[key].length - 1],
          dependents: [
            ...(state.searchModel[key][state.searchModel[key].length - 1]?.dependents ?? []),
            ...data,
          ],
        },
      ],
    },
  };
  return _state;
};

export const isDefaultSearch = (state: SearchState, group: SearchFilterTypes) => {
  let searchGroup: SearchGroup<EventType>[] | SearchGroup<UserType>[];
  let defaultType: EventType | UserType;

  switch (group) {
    case SearchFilterTypes.Events:
      searchGroup = state.uiModel.events;
      defaultType = defaultEventType;
      break;
    case SearchFilterTypes.NotEvents:
      searchGroup = state.uiModel.notEvents;
      defaultType = defaultNotEventType;
      break;
    case SearchFilterTypes.Users:
      searchGroup = state.uiModel.users;
      defaultType = defaultUserType;
      break;
  }
  return (
    searchGroup.length === 1 &&
    searchGroup[0] &&
    equalType(defaultType, searchGroup[0].primary) &&
    searchGroup[0].dependents.length === 0
  );
};
